import React from 'react';
import { ContentOption } from '../../Types/Types.ts';

type HorizontalOptionProps = {
  option: ContentOption;
  onClick: () => void;
};

const HorizontalOption = ({ option, onClick }: HorizontalOptionProps) => {
  return (
    <div className="horizontal-option d-flex mb-4 px-1 py-1" onClick={onClick}>
      <div className="image-wrapper d-flex justify-content-center w-100">
        {option.ImageUrl && <img src={option.ImageUrl} alt={option.ImageAlt} />}
      </div>
      <div className="info d-flex flex-column justify-content-center">
        {option.Title && <h5 className="mb-1">{option.Title}</h5>}
        {option.Description && <p>{option.Description}</p>}
      </div>
    </div>
  );
};

export default HorizontalOption;
